<template>
	
    <div>

        <Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
        <Hero :slides="hero.slides" :smallHero="hero.smallHero"></Hero>

        <div class="container">

            <Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>

            <div class="columns row">

                <div class="sidebar col-lg-3">

                    <SidebarMenu v-if="sidebarMenu" :sidebarMenu="sidebarMenu"></SidebarMenu>

                </div>

                <div class="main col-lg-8 offset-lg-1">

                    <!--add "two-column" class for layout as per commissioner-landing-page-->
                    <Bios v-if="bioSection" :bioSection="bioSection"></Bios>
                    <div class="event-details has-hr">
                        <div class="title">
                            event name here
                        </div>
                        <div class="detail">
                            Day: Thursday, April 11
                        </div>
                        <div class="detail">
                            Time of the Event: 6:30 - 8:00pm
                        </div>
                        <div class="detail">
                            Location: 10 Park Plaza, Alpharetta, GA 30009
                        </div>
                        <a class="link" href="#">
                            view on map
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                        </a>
                        <div class="detail more-info">
                            For more information contact <a href="mailto:#">xyz@fultoncountyga.gov</a> or call <a href="tel:404-964-8255">404-964-8255</a>
                        </div>
                        <div title="Add to Calendar" class="addeventatc">
                            Add to Calendar
                            <span class="start">21-05-2019 08:00</span>
                            <span class="end">21-05-2019 10:00</span>
                            <span class="timezone">America/Los_Angeles</span>
                            <span class="title">Summary of the event</span>
                            <span class="description">Description of the event</span>
                            <span class="location">Location of the event</span>
                        </div>
                    </div>
                </div>
                <div class="container faq-list">
                    <!--Currently each accordion within an accordion group will close automatically if another is clicked.
                If this functionality is not needed a class of keep-open can be added to a accordion-container to prevent this-->
                    <div class="row accordion-group">
                        <div class="accordion-container faq-item col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    FAQ title 1
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <div class="faq-ans">
                                    <p>
                                        The capital fox super simple dickory passion thread Hasselhoff Sharepoint Robin Reviews. Sharepoint innovation abbey road serves Hasselhoff accountability shopping desktop excellence Skype the wedge organization data. Copper the wedge crawl hoteling Oakland palm pilot blackberry. Hoteling are you on mute Sitecore you're not sharing your screen. Hunky dory Coca-Cola La Croix wi-fi La Croix quick win starfish thinkpad zune technology. Yammer hardware pretzels meenie work gif data zune Sitecore quick win assemble zuma. Content sarves excellence culture intranet starfish el porto. Thinkpad dukes of hazard focus my space you're not sharing your screen New York super simple. Spark emoji chunky staffing development excellence quick win. Dukes of hazard punchline zune rock & roll engineering laptop sorry I'm late palm pilot.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-container faq-item col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    FAQ title 2 that is a little longer
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <div class="faq-ans">
                                    <p>
                                        Sharepoint transform passion starfish make it pop gif walk Episerver excellence testing. Rock & roll ping pong culture innovation rock & roll Raizlabs sugarbush La Croix dagobah. Fidget toy cathedral sugarbush cloud ctrl alt delete. Wi-fi san onofre sarves cold brew mos eisley mvp Coca-Cola pride teams super simple integrity pourcast. Technology video games global performance audit. Yammer development mobile beer Chicago focus bowling platforms hawa mahal magic Episerver. Sriracha need moar coffee dukes of hazard sarves content nerf war. Anchorman hunky dory jackson hole miney thinkpad whistler amer intrapreneurship. Audit latham square starfish need moar coffee stax magic dagobah agency of the future hotlist. Thread teams New York fireside chat mos eisley the wedge blackberry the dungeon.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-container faq-item col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    FAQ title 3 that is really long and might end up wrapping to the next line if I keep coming up with words to write
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <div class="faq-ans">
                                    <p>
                                        Migration Starbucks palm pilot platforms unicorn dragons. Science fair Boston thinkpad focus anchorman abbey road latham square war room sarvis matrix war room motown fireside chat. Laptop innovation work coffee serve wi-fi Episerver creative. Starbucks out of scope zune teams hardware motown interface moe migration Boston spark hardware. Thinkpad intranet amer experts cloud quick wins latham square innovation. Gif Robin Reviews ctrl alt delete the blindside augmented thinkpad alexa. The dungeon floppy disk Detroit ctrl alt delete thinkpad san onofre palm pilot Robin Reviews coffee sipping time sarvis sugarbush Los Angeles. Technology stowe app Raizlabs dickory lord of the mini coop mobile. Wi-fi headphones cathedral my space the port serve. Baywatch mobile super simple i-frame stowe miney hunky dory rainbows works on my local alexa surves culture please submit your timesheet.
                                    </p>
                                    <p>
                                        Coffee mos eisley zune e-commerce coffee lift and shift Dallas sarvis meetings. Dragons powershell all the things the lair Photoshop platforms. La Croix the lair pretzels hawa mahal expertise Raizlabs fireside chat accountability hawa mahal thinkpad management sorry I'm late Photoshop. Whistler management starfish Robin Reviews Detroit platforms. Are you on mute ping pong headphones anchorman board games insight in the work anchorman palm pilot ctrl alt delete. Cheese and whine snack time gif Teams magic alexa the blindside migration rubber duck. The wedge Detroit the capital agile miney mobile parter gif serves learning fox teams content. Intrapreneurship you're not sharing your screen mobile passion i-frame analytics. Bowling agile fidget toy transform stowe anchorman excellence. Hasselhoff the dungeon e-commerce testing transform stranger things.
                                    </p>
                                    <p>
                                        Zune serve insight surves stowe fidget toy need moar coffee pourcast innovation Sriracha. Robin Reviews cheese and whine agile matrix experts design what's the ask. Low hanging fruit the capital people unicorn synergy fireside chat moe emoji crawl magic ping pong. Internet outage make it pop surves Starbucks unicorn the dungeon Jaipur hyde war room productivity operations. Rainbows Yammer okemo creative Teams laptop. The nest studio one are you on mute internet outage rock & roll virtual dickory miney copper. Sarves intranet lord of the mini coop nerf war the lair low hanging fruit fox what's the ask smart. Management baywatch moe fox content Sharepoint integrity. Management gif loon desktop. Meetings collaboration smart productivity insight content Episerver learning meetings.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contact-info-table container-fluid theme-light-blue">
            <header class="title-header">
                <div class="backdrop">
                    <h2>
                        <span class="subtitle">Justice, Elected &</span>
                        <span class="title">Appointed Agencies</span>
                    </h2>
                </div>
            </header>
            <table class="container">
                <tr>
                    <th>Department</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email Address</th>
                </tr>
                <tr>
                    <td>Arts & Culture</td>
                    <td>John Doe</td>
                    <td>
                        <a href="tel:555-555-5555">555-555-5555</a>
                    </td>
                    <td>
                        <a href="mailto:address@email.com">John@email.com</a>
                    </td>
                </tr>
                <tr>
                    <td>Finance</td>
                    <td>Jane Doe</td>
                    <td>
                        <a href="tel:555-555-5555">555-555-5555</a>
                    </td>
                    <td>
                        <a href="mailto:address@email.com">Jane@email.com</a>
                    </td>
                </tr>
                <tr>
                    <td>Arts & Culture</td>
                    <td>John Doe</td>
                    <td>
                        <a href="tel:555-555-5555">555-555-5555</a>
                    </td>
                    <td>
                        <a href="mailto:address@email.com">John@email.com</a>
                    </td>
                </tr>
                <tr>
                    <td>Finance</td>
                    <td>Jane Doe</td>
                    <td>
                        <a href="tel:555-555-5555">555-555-5555</a>
                    </td>
                    <td>
                        <a href="mailto:address@email.com">Jane@email.com</a>
                    </td>
                </tr>
                <tr>
                    <td>Arts & Culture</td>
                    <td>John Doe</td>
                    <td>
                        <a href="tel:555-555-5555">555-555-5555</a>
                    </td>
                    <td>
                        <a href="mailto:address@email.com">John@email.com</a>
                    </td>
                </tr>
                <tr>
                    <td>Finance</td>
                    <td>Jack Doe</td>
                    <td class="font-lt">
                        N/A
                    </td>
                    <td class="font-lt">
                        N/A
                    </td>
                </tr>

            </table>
        </div>
        <UpcomingEvents :subtitle="upcomingEvents.subtitle" :title="upcomingEvents.title" :featuredEvents="upcomingEvents.featuredEvents" :miniEvents="upcomingEvents.miniEvents" :cta="upcomingEvents.cta"></UpcomingEvents>
        <DistrictLocator :title="districtLocator.title" :body="districtLocator.body" :form="districtLocator.form" :summary="districtLocator.summary" :image="districtLocator.image"></DistrictLocator>
        <Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>

    </div>
	
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
	import Hero from '../components/Hero/Hero.vue';
	import Breadcrumbs from '../components/Global/Breadcrumbs.vue';
	import SidebarMenu from '../components/Global/SidebarMenu.vue';
	import Bios from '../components/Bios/Bios.vue';
	import UpcomingEvents from '../components/Events/UpcomingEvents.vue';
	import DistrictLocator from '../components/DistrictLocator/DistrictLocator.vue';
	import Footer from '../components/Footer/Footer.vue';
	import axios from 'axios';
	
	export default {
		name: 'CommissionerLandingPage',
		
		components: {
			Header,
			Hero,
			Breadcrumbs,
			SidebarMenu,
			Bios,
			UpcomingEvents,
			DistrictLocator,
			Footer
		},
		
		data() {
			return {
				breadcrumbs: [],
				bioSection: {},
				sidebarMenu: [],
				
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
                hero: {
					slides: [],
					smallHero: {}
				},
				// bios: {
				// 	subtitle: "",
				// 	title: "",
				// 	bioSection: [],
				// 	cta: {}
				// },
				upcomingEvents: {
				},
				districtLocator: {
					title: "",
					body: "",
					form: {},
					summary: {},
					image: ""
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let hero = 'SampleData/HeroData.json';
			axios.get(hero).then(function(response) {
				
				self.hero.slides = response.data.slides;
				self.hero.smallHero = response.data.smallHero;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
			if (endpointID) {
				
				let endpoint = 'SampleData/' + endpointID + '.json';
	
				axios.get(endpoint).then(function(response) {
					
					self.breadcrumbs = response.data.breadcrumbs;
					self.sidebarMenu = response.data.sidebarMenu;
					self.bioSection = response.data.bioSection;
				})
				.catch(function (error) {
					console.log(error);
				});
			}
			
			let upcomingEvents = 'SampleData/UpcomingEventsData.json';
			axios.get(upcomingEvents).then(function(response) {
				
                self.upcomingEvents = response.data;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let districtLocator = 'SampleData/DistrictLocatorData.json';
			axios.get(districtLocator).then(function(response) {
				
				self.districtLocator.title = response.data.title;
				self.districtLocator.body = response.data.body;
				self.districtLocator.form = response.data.form;
				self.districtLocator.summary = response.data.summary;
				self.districtLocator.image = response.data.image;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>